import { useMessageStore } from '../stores/messageStore';
import { useLeaseStore } from '../stores/leaseStore';
import { useUserStore } from '../stores/userStore';
import { useListingStore } from '../stores/listingStore';
import { useListingStats } from '../stores/listingStats';
import { useBillingStore } from '../stores/billingStore';

export const resetAllStores = () => {
  // Reset all stores to initial state
  useMessageStore.getState().resetStore();
  useLeaseStore.getState().resetStore();
  useUserStore.getState().resetStore();
  useListingStore.getState().resetStore();
  useListingStats.getState().resetStore();
  useBillingStore.getState().resetStore();

  // Clear all localStorage data
  localStorage.clear();
  
  // Force page reload to ensure clean state
  window.location.reload();
};